import { Component, EventEmitter, ViewChild, ElementRef, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie';

import { UserService } from '../../services/user.service';
import { SocialService } from '../../services/social.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

import { Account } from '../../models/account';
import { Post } from '../../models/post';
import { Item } from '../../models/item';
import { Product } from '../../models/product';
import { Notification } from '../../models/notification';


@Component({
  selector: 'userview',
  templateUrl: './view.component.html',
  providers: [ UserService, SocialService, StoreService ],
  animations: [
	trigger('flyInOut', [
		state('in', style({height: '330px', transform: 'translateX(0)', opacity: 1})),
		transition('void => *', [
			style({ transform: 'translateY(50px)', opacity: 0}),
			group([
				animate('0.3s 0.1s ease', style({
					transform: 'translateY(0)',
				})),
				animate('0.3s ease', style({
					opacity: 1
				}))
			])
		]),
		transition('* => void', [
			group([
				animate('0.3s ease', style({
					transform: 'translateY(50px)',
					opacity: 0
				}))
			])
		])
	])
  ]

})
export class ViewComponent implements OnInit {
		
	title: string;
	subtitle: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	accountPage: string;
	writtenProfile: string;

	accountClaimsNumber: number;
	accountItemNumber: number;
	showUserClaims: number;
	showUserItem: number;
	friendcount: number;
	profile: Account;
	accounts: Account;
	requests: Account;
	notifications: Notification;
	accountItems: Item;
	accountClaims: Product;
	feed: Post;

	loadingItems: boolean;
	loadingClaims: boolean;
	hasItems = false;
	hasClaims = false;

	constructor(private user: UserService,
  			  private store: StoreService,
  			  private social: SocialService,
			  private sanitizer: DomSanitizer,
  			  private router: Router,
  			  private route: ActivatedRoute,
  			  private cookie: CookieService) {
		
		this.showUserClaims = 0;
		this.showUserItem = 0;

		this.loadingItems = true;
		this.loadingClaims = true;

	}

	getItems(user?) {
		Promise.resolve( this.store.getPurchasedItems(user) ).then((items) => {
			this.hasItems = (items[0]) ? true : false; 
			this.accountItems = items;
			this.loadingItems = false;
			Promise.resolve( this.store.countPurchasedItems(user) ).then( (count) => {
				this.accountItemNumber = count;
			});
		});
	}

	getClaims(user?) {
		Promise.resolve( this.store.getPurchasedProducts(user) ).then((items) => {
			this.hasClaims = (items[0]) ? true : false; 
			this.accountClaims = items;
			this.loadingClaims = false;
			Promise.resolve( this.store.getPurchasedProductsCount(user) ).then((count) => {
				this.accountClaimsNumber = count;
			});
		});
	}

	getFeed(user?) {
		Promise.resolve(this.social.feed(user)).then((posts) => {
			this.feed = posts;
		});
	}

	changePage(page) {
		this.accountPage = page
	}

	viewUser(username) {
		Promise.resolve( this.user.getProfile(username) ).then((profile) => {
			this.accounts = profile;
			this.title = profile[0].username;
			this.subtitle = profile[0].tagline;
			this.writtenProfile = profile[0].profile;
		});
	}


	nextClaim() {
		this.showUserClaims = (this.showUserClaims+1<this.accountClaimsNumber) ? this.showUserClaims+1 : this.showUserClaims;
	}

	prevClaim() {
		this.showUserClaims = (this.showUserClaims>0) ? this.showUserClaims-1 : this.showUserClaims;
	}

	nextItem() {
		this.showUserItem = (this.showUserItem+1<this.accountItemNumber) ? this.showUserItem+1 : this.showUserItem;
	}

	prevItem() {
		this.showUserItem = (this.showUserItem>0) ? this.showUserItem-1 : this.showUserItem;
	}

	updateUser() {
		let username = this.route.snapshot.params['id'];
		if ( username ) {
			this.viewUser(username );
			this.getFeed( username );
			this.getItems( username );
			this.getClaims( username );
		}
	}

	/* On with the show */
	ngOnInit() {
		this.accountPage = 'about';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("/assets/img/header-square.jpg")' );
		this.headerHeight = '500px';
		this.updateUser();

		this.router.events
			.filter(event => event instanceof NavigationEnd)
			.map(() => this.router.routerState.root)
			.subscribe((event) => {
				this.updateUser();
			});

	}


}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/view/view.component.ts